// Function to get permissions from local storage
const getPermissions = () => {
    const storedPermissions = localStorage.getItem('permissions');
    return storedPermissions ? JSON.parse(storedPermissions) : [];
};

// Function to check if the user has a specific permission
export const hasPermission = (requiredPermissionID) => {
    const userPermissions = getPermissions();
    return userPermissions?.some(
        (permission) => permission.permissionID === requiredPermissionID && permission.permissionStatus === 1
    );
};

// Function to filter the sidebar menu based on user permissions
export const filterMenuItems = (menuItems) => {
    const userPermissions = getPermissions();

    return menuItems
        .filter(item => {
            // Check if the menu item has a required permission ID
            if (item.requiredPermissionID) {
                return userPermissions.some(
                    (permission) =>
                        permission.permissionID === item.requiredPermissionID &&
                        permission.permissionStatus === 1
                );
            }
            return true;
        })
        .map(item => ({
            ...item,
            // Recursively filter children if they exist
            children: item.children ? filterMenuItems(item.children) : undefined,
        }));
};

// New function to return true/false if the permission ID matches
export const isPermissionGranted = (requiredPermissionID) => {
    const userPermissions = getPermissions();
    return userPermissions?.some(
        (permission) => permission.permissionID === requiredPermissionID && permission.permissionStatus === 1
    );
};

// CHECK OUTLET DROPDOWN PERMISSION
export const isDropdownPermission = (roleId) => {
    const accessPermisstionRoleIds = [0]
    if(accessPermisstionRoleIds.includes(roleId)){
        return true
    }
    return false
};